var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"absolute":"","app":"","centered":"","content-class":"noselect text-center justify-center"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" Made with ❤️ in India. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }